<template>
  <div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Status</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <v-select
          :searchable="true"
          :options="optionStatus"
          :clearable="true"
          v-model="selectedStatus"
        >
        </v-select>
      </div>
    </div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th>Supplier Code</vs-th>
        <vs-th>Warehouse Code</vs-th>
        <vs-th>PO Code</vs-th>
        <vs-th>External Code</vs-th>
        <vs-th>Barcode</vs-th>
        <vs-th>Posting Date</vs-th>
        <vs-th>Payment Term</vs-th>
        <vs-th>Due Date</vs-th>
        <vs-th>Total Amount</vs-th>
        <vs-th>Note</vs-th>
        <vs-th>Down Payment</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Remark</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.Data.supplier_code">
            {{ tr.Data.supplier_code }}
          </vs-td>

          <vs-td :data="tr.Data.warehouse_code">
            {{ tr.Data.warehouse_code }}
          </vs-td>

          <vs-td :data="tr.Data.po_code">
            {{ tr.Data.po_code }}
          </vs-td>

          <vs-td :data="tr.Data.external_code">
            {{ tr.Data.external_code }}
          </vs-td>

          <vs-td :data="tr.Data.barcode">
            {{ tr.Data.barcode }}
          </vs-td>

          <vs-td :data="tr.Data.posting_date">
            {{ tr.Data.posting_date }}
          </vs-td>

          <vs-td :data="tr.Data.payment_term">
            {{ tr.Data.payment_term }}
          </vs-td>

          <vs-td :data="tr.Data.due_date">
            {{ tr.Data.due_date }}
          </vs-td>

          <vs-td :data="tr.Data.total_amount">
            {{ tr.Data.total_amount }}
          </vs-td>

          <vs-td :data="tr.Data.note">
            {{ tr.Data.note }}
          </vs-td>

          <vs-td :data="tr.Data.down_payment">
            {{ tr.Data.down_payment }}
          </vs-td>

          <vs-td :data="tr.Status">
            {{ tr.Status }}
          </vs-td>

          <vs-td :data="tr.Remark">
            {{ tr.Remark }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";

export default {
  components: { vSelect },
  props: {
    baseUrl: {
      type: String,
    },
    logImportID: {
      type: Number,
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YYYY");
      }
    },
  },
  data() {
    return {
      table: this.tableDefaultState(),
      optionStatus: [],
      selectedStatus: "",
      selectedSearchKeys: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },

    getData() {
      this.$vs.loading();
      const params = {
        length: this.table.length,
        page: this.table.page,
        search: this.table.search,
        order: this.table.order,
        sort: this.table.sort,
        log_begbal_id: this.logImportID,
        status: this.selectedStatus,
        search_keys:
          this.selectedSearchKeys.length > 0 ? this.selectedSearchKeys : [""],
      };

      this.$http
        .get("/api/v1/import/log-begbal-lines", { params })
        .then((resp) => {
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;

            if (
              this.table.data.Data &&
              this.selectedSearchKeys.length === 0 &&
              this.table.length > 0
            ) {
              this.selectedSearchKeys = Object.keys(
                this.table.data.Data
              ).filter((key) => key !== "Status" && key !== "Remark");
            }

            if (this.selectedStatus === "") {
              this.optionStatus = [];
            }

            this.table.data.forEach((e) => {
              if (
                !this.optionStatus.includes(e.Status) &&
                this.selectedStatus === ""
              ) {
                this.optionStatus.push(e.Status);
              }
            });

            this.setStartEnd();
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.error(error);
          this.$vs.loading.close();
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
  },
  watch: {
    logImportID() {
      console.log("logImportID changed");
      this.getData();
    },
    selectedStatus() {
      console.log("selectedStatus changed");
      this.getData();
    },
    selectedSearchKeys() {
      console.log("selectedSearchKeys changed");
      this.getData();
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
